import { Pipe, PipeTransform } from "@angular/core";
import * as moment from "moment";

@Pipe({
    name:'localDate'})

export class LocalDatePipe implements PipeTransform {
  transform(value: any): any {
    var UTCTime = moment.utc(value);
    if(value == null){
        return " ";
    }else{
    return  UTCTime.local().format('DD-MM-yy, hh:mm:ss A');
  }
}  
}